<template>
  <div class="scroller">
    <div class="resource">
      <h2 class="resource__heading">Settings</h2>
      <form @submit.prevent="onSubmit">
          <div class="grid form">
            <div class="grid__column--six">
              <div class="form__group">
                <label class="form__label" for="title">Title:</label>
                <input
                  type="text" id="title" name="title"
                  class="form__input"
                  v-model="settings.title"
                />
              </div>
              <div class="form__group">
                <label class="form__label" for="title">Street:</label>
                <input
                  type="text" id="street" name="street"
                  class="form__input"
                  v-model="settings.street"
                />
              </div>
              <div class="form__group">
                <label class="form__label" for="country">Country:</label>
                <input
                  type="text" id="country" name="country"
                  class="form__input"
                  v-model="settings.country"
                />
              </div>
              <div class="form__group">
                <label class="form__label" for="phone">Phone:</label>
                <input
                  type="text" id="phone" name="phone"
                  class="form__input"
                  v-model="settings.phone"
                />
              </div>
              <div class="form__group">
                <label class="form__label" for="phone">Header navigation:</label>
                <select v-model="settings.navigation_id">
                  <option v-for="navigation in navigations" :key="navigation.id" :value="navigation.id">
                    {{ navigation.title }}
                  </option>
                </select>
              </div>
              <div class="form__group">
                <label class="form__label" for="instagram">Instagram:</label>
                <input
                  type="text" id="instagram" name="instagram"
                  class="form__input"
                  v-model="settings.additionals.socials.instagram"
                />
              </div>
              <div class="form__group">
                <label class="form__label" for="linkedin">Linkedin:</label>
                <input
                  type="text" id="linkedin" name="linkedin"
                  class="form__input"
                  v-model="settings.additionals.socials.linkedin"
                />
              </div>
            </div>
            <div class="grid__column--six">
              <div class="form__group">
                <label class="form__label" for="email">Email:</label>
                <input
                  type="text" id="email" name="email"
                  class="form__input"
                  v-model="settings.email"
                />
              </div>
              <div class="form__group">
                <label class="form__label" for="town">Town:</label>
                <input
                  type="text" id="town" name="town"
                  class="form__input"
                  v-model="settings.town"
                />
              </div>
              <div class="form__group">
                <label class="form__label" for="zip">Zip:</label>
                <input
                  type="text" id="zip" name="zip"
                  class="form__input"
                  v-model="settings.zip"
                />
              </div>
              <div class="form__group">
                <label class="form__label" for="working_hours">Working hours:</label>
                <input
                  type="text" id="working_hours" name="working_hours"
                  class="form__input"
                  v-model="settings.working_hours"
                />
              </div>
              <div class="form__group">
                <label class="form__label" for="copyright_text">Copyright text:</label>
                <input
                  type="text" id="copyright_text" name="copyright_text"
                  class="form__input"
                  v-model="settings.copyright_text"
                />
              </div>
              <div class="form__group">
                <label class="form__label" for="facebook">Facebook:</label>
                <input
                  type="text" id="facebook" name="facebook"
                  class="form__input"
                  v-model="settings.additionals.socials.facebook"
                />
              </div>
              <div class="form__group">
                <label class="form__label" for="youtube">Youtube:</label>
                <input
                  type="text" id="youtube" name="youtube"
                  class="form__input"
                  v-model="settings.additionals.socials.youtube"
                />
              </div>
            </div>
          </div>
          <h2 class="resource__heading">Translation strings</h2>
          <div class="form">
            <div class="form__group">
              <p class="builder__message" v-if="settings.additionals.translations.length === 0"><font-awesome-icon :icon="['fal', 'smile-plus']" class="navigation__icon"/><br /> Define translatable string elements in your theme.</p>
              <div class="flex" v-for="(string, index) in settings.additionals.translations" :key="`translation-string-${index}`">
                <div class="flex__column">
                  <div class="form__group">
                    <label class="form__label" for="hrDiscount">Reference name:</label>
                    <input
                      type="text" id="hrDiscount" name="hrDiscount"
                      class="form__input"
                      v-model="string.name"
                    />
                  </div>
                </div>
                <div class="flex__column" v-for="language in languages" :key="`translation-string-${language.iso}`">
                  <label class="form__label" for="hrDiscount">{{ language.iso.toUpperCase() }} <template v-if="string.name">&mdash; {{ string.name }}</template></label>
                  <input
                    type="text" id="hrDiscount" name="hrDiscount"
                    class="form__input"
                    v-model="string[language.iso]"
                  />
                </div>
              </div>

              <div class="flex__row">
                <div class="flex__oneFull">
                  <button type="button" class="btn btn--primary mt1" @click="addTranslation">Add string translation</button>
                </div>
              </div>
            </div>

            <div class="flex__row">
              <div class="flex__oneFull">
                <button type="submit" class="btn btn--primary btn--fixed">UPDATE</button>
              </div>
            </div>
          </div>
      </form>
    </div>
  </div>
</template>

<script>
import * as types from '@/store/types.js'

export default {
  data () {
    return {
      settings: {
        additionals: {
          translations: [],
          socials: {}
        }
      },
      navigations: []
    }
  },
  methods: {
    addTranslation () {
      if (this.settings.additionals.translations === undefined) this.$set(this.settings.additionals, 'translations', [])
      this.settings.additionals.translations.push({ name: '' })
    },
    onSubmit () {
      axios.put('/settings', this.settings)
        .then(response => {
          swal('Successfully updated', '', 'success')
        })
    }
  },
  computed: {
    languages () {
      return this.$store.getters[types.LANGUAGES]
    }
  },
  beforeRouteEnter (to, from, next) {
    axios.all([
      axios.get('/settings'),
      axios.get('/navigations')
    ]).then(axios.spread((settings, navigations) => {
      next(vm => {
        vm.settings = settings.data.data
        vm.navigations = navigations.data.data
      })
    }))
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Settings.vue